export default __webpack_public_path__ + "static/1965-0ca46ee196150c76f090f5e687d05ad2.gif";